// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_7tM","cls2":"PaperAbstract-cls2_CrX PaperAbstract-cls1_7tM"};